import { AgreementCode } from "./AgreementCode";
import { ApplicantType } from "./ApplicantType";
import { ApplicationType } from "./ApplicationType";

/**
 * Corporate applicants include both regular companies and sole proprietorships.
 */
export const isCorporateApplicant = (applicantType: ApplicantType): boolean =>
    applicantType === ApplicantType.Corporate || applicantType === ApplicantType.SoleProprietorship;

/**
 * Determines whether an agreement is available for a given application type and applicant type.
 * Loan applications are split into private vs corporate by applicant type.
 */
export const agreementMatchesApplication = (
    agreement: { isPrivate: boolean, isCorporate: boolean, isPersonnel: boolean },
    type: ApplicationType,
    applicantType: ApplicantType): boolean => {
    switch (type) {
        case ApplicationType.Loan:
            return isCorporateApplicant(applicantType)
                ? agreement.isCorporate
                : agreement.isPrivate && !agreement.isPersonnel;
        case ApplicationType.Personnel:
            return agreement.isPrivate && agreement.isPersonnel;
        case ApplicationType.Leasing:
            return false;
    }
};

export const isMarineLoanAgreementCode = (agreementCode: AgreementCode | undefined): boolean => {
    return agreementCode === AgreementCode.YamahaBoatLoan || agreementCode === AgreementCode.YamahaMarineLoan;
}

export const isYamahaBoatLoanCode = (agreementCode: AgreementCode | undefined): boolean => {
    return agreementCode === AgreementCode.YamahaBoatLoan;
}

export const isYamahaMarineLoanCode = (agreementCode: AgreementCode | undefined): boolean => {
    return agreementCode === AgreementCode.YamahaMarineLoan;
}

export const isObjectYoungerThan8Years = (objectAgeMonths: number | null): boolean => {
    return objectAgeMonths != null && objectAgeMonths <= 96;
}